import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      style={{
        position:        "fixed",
        bottom:          "28px",
        right:           "28px",
        zIndex:          9999,
        width:           "46px",
        height:          "46px",
        borderRadius:    "50%",
        border:          "1px solid rgba(14,26,26,0.10)",
        backgroundColor: "rgba(255,255,255,0.75)",
        backdropFilter:  "saturate(180%) blur(16px)",
        WebkitBackdropFilter: "saturate(180%) blur(16px)",
        boxShadow:       "0 4px 20px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06)",
        display:         "flex",
        alignItems:      "center",
        justifyContent:  "center",
        cursor:          "pointer",
        opacity:         visible ? 1 : 0,
        transform:       visible ? "scale(1) translateY(0)" : "scale(0.85) translateY(8px)",
        pointerEvents:   visible ? "auto" : "none",
        transition:      "opacity 0.25s ease, transform 0.25s ease, box-shadow 0.2s ease, background-color 0.2s ease",
        outline:         "none",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform     = "scale(1.08) translateY(-2px)";
        e.currentTarget.style.boxShadow     = "0 8px 28px rgba(0,0,0,0.14), 0 2px 6px rgba(0,0,0,0.08)";
        e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.92)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform     = "scale(1) translateY(0)";
        e.currentTarget.style.boxShadow     = "0 4px 20px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06)";
        e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.75)";
      }}
      onFocus={(e) => {
        e.currentTarget.style.outline    = "2px solid #0F766E";
        e.currentTarget.style.outlineOffset = "2px";
      }}
      onBlur={(e) => {
        e.currentTarget.style.outline = "none";
      }}
    >
      <ArrowUp
        size={18}
        strokeWidth={1.75}
        style={{ color: "#0A0A0A" }}
      />
    </button>
  );
}
